import { React, useState, useEffect, useRef } from "react";
import { RightLayoutContainer, PageTitleComp, DetailFields, ProfileImageUpload } from "../../styledElements";
import styled from "styled-components";
import { Button, Row, Col, Form, Input, PageHeader, Upload, message } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import CountryPhoneInput, { ConfigProvider } from 'antd-country-phone-input';
import en from 'world_countries_lists/data/countries/en/world.json';
import 'antd-country-phone-input/dist/index.css';
import 'flagpack/dist/flagpack.css';
import { editProfile, getProfile, uploadImage } from "../../../Services/profileServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import DefaultProfilePicture from "../../../Assets/Images/default-pic.png";
import { getUserProfile } from "../../../Services/loginServices";
import {useNavigate } from "react-router";
import { getImageURL } from "../../../Services/deckleMatchServices";
import { newUploadOrders } from "../../../Services/uploadServices";

const ProfileEditData = (props) => {
    const [profile, setProfile] = useState();
    const [form] = Form.useForm();
    const [toaster, setToaster] = useState({
        error: "",
        msg: "",
    });
    const [showToaster, setShowToaster] = useState(false);
    const fileUploadRef = useRef();
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();

   useEffect(() => {
  getProfile().then(resp => {
    let body = {
      bucket_key: resp.data.data.profile_picture,
      operation:"download"
    };

    if (resp.data.data.profile_picture) {
      getImageURL(body).then(url => {
        setProfile({
          ...resp.data.data,
          profile_picture: url,
        });
      });
    } else {
      setProfile(resp.data.data);
    }
  });
}, []);


    useEffect(() => {
        if (profile) {
            form.setFieldsValue({
                contact_number: {
                    short: profile.contact_number?.substring(
                        0,
                        profile.contact_number.indexOf("-")
                    ),
                    phone: profile.contact_number?.substring(
                        profile.contact_number.indexOf("-") + 1
                    ),
                }
            })
        }

    }, [profile])


    const getFlag = (short) => {
        const data = require(`world_countries_lists/data/flags/24x24/${short.toLowerCase()}.png`);
        // for dumi
        if (typeof data === 'string') {
            return data;
        }
        // for CRA
        return data.default;
    };

    const onFinish = (values) => {
        //let url = URL.createObjectURL(values.profile_picture.fileList[0]);
        if (selectedImage?.name) {
            // uploadImage(selectedImage).then(resp => { }).catch(err => { })
                getImageURL({ bucket_key: selectedImage.name, operation: "upload" }).then(resp => {
                    newUploadOrders(resp, selectedImage)
                })
        }
        const body = {
            name: values.name,
            contact_number: `${values.contact.short}-${values.contact.phone}`,
            email: values.email,
            department: values.department,
            //profile_picture: values.profile_picture?.fileList[0]?.originFileObj || ""
            profile_picture: selectedImage ? `${selectedImage.name}` : profile.profile_picture ? profile.profile_picture : ``
        }
        editProfile(body).then(response => {
            setToaster({ error: false, msg: "Your profile is successfully updated" })
            setShowToaster(true);
            getUserProfile().then(resp=>{
                localStorage.setItem("user-details", JSON.stringify(resp));
                navigate("../general");
                window.location.reload();
              });
            setTimeout(() => setShowToaster(false), 3000);
        }).catch(err => console.log(err))
    }

    const uploadImageHandler = (event) => {
        // let imageTag = document.getElementById("imageId")
        // imageTag.src = URL.createObjectURL(event.target.files[0])
        // setSelectedImage(event.target.files[0])

        const file = event.target.files[0];

        if (!file) return;

        // Extract file extension in lowercase
        const ext = file.name.split('.').pop().toLowerCase();

        // Allowed extensions list
        const allowedExtensions = ['png', 'jpg'];

        if (!allowedExtensions.includes(ext)) {
            // message.error("Invalid file type. Only PNG, JPG files are allowed.");
            setToaster({ error: true, msg: "Invalid file type. Only PNG, JPG files are allowed." })
            setShowToaster(true);
            setTimeout(() => setShowToaster(false), 3000);
            event.target.value = ""; // Clear the input
            return;
        }

        // If valid:
        let imageTag = document.getElementById("imageId");
        imageTag.src = URL.createObjectURL(file);
        setSelectedImage(file);
    }

    const deleteImage = () => {
        setSelectedImage(null)
        setProfile({ ...profile, profile_picture: "" })
    }
    return (
        profile ?
            <RightLayoutContainer>
                <PageTitleComp>
                    <PageHeader
                        ghost={false}
                        title="Edit Profile"
                        extra={[
                            <Button key="3" onClick={() => window.history.back()} className="textTypeBtn">Cancel changes</Button>,
                            <Button key="2" onClick={() => { form.submit() }} className="themeBtn"><Iconmoon icon="addcircle" size={14} color="#ffffff" />Save Profile</Button>,
                        ]}
                    ></PageHeader>
                </PageTitleComp>
                <DetailFields>
                    <HaberForm>
                        <div className="groupDetailWrap profileWraped">
                            <Form
                                name="basic"
                                autoComplete="off"
                                className="haberLogin"
                                form={form}
                                onFinish={onFinish}
                                rules={[
                                    { required: true, message: "This field is mandatory" },
                                    { max: 50, message: "Name cannot have more than 50 characters" },
                                ]}>
                                <Row gutter={[16, 16]} className="groupForm">
                                    <Col span={24}>
                                        <Row className="centerAlign">
                                            <Col span={12}>
                                                <div className="boxFieldTitle">
                                                    <label>
                                                        Profile Picture
                                                    </label>
                                                    <p>
                                                        This is an auto generated code
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col span={12} className="blockBreak">
                                                <div className="boxFormType profileDragger" style={{ marginBottom: "0" }}>
                                                    <Form.Item>
                                                        <ProfileImageUpload>
                                                            <div className="bioPic">
                                                                <div className="bio-picImg">
                                                                    {profile.profile_picture && !selectedImage && <img id="" src={`${profile.profile_picture}`} alt="Profile Picture" />}
                                                                    <img id="imageId" style={!selectedImage?.name ? { visibility: "hidden" } : {}} src="" alt="Profile Picture" />
                                                                    {!selectedImage && !profile.profile_picture && <img id="defaultPic" src={DefaultProfilePicture} alt="Profile Picture" />}
                                                                </div>
                                                                <div className="bio-data bio-uploaded">
                                                                    <input
                                                                        type="file"
                                                                        ref={fileUploadRef}
                                                                        style={{ display: "none" }}
                                                                        name="myImage"
                                                                        accept=".png, .jpg"
                                                                        onChange={uploadImageHandler}
                                                                    />
                                                                    <div onClick={() => { fileUploadRef.current.click() }} className="uploadBtnFx themeBtn">
                                                                        <p className="ant-upload-text">
                                                                            <span>Upload new picture</span>
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <Button onClick={deleteImage} className="themeBtn noBg"> Delete </Button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ProfileImageUpload>
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Name</label>
                                                    <p>The name by which you would like to be known to your colleagues</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                    <Form.Item
                                                        name="name"
                                                        rules={[{}]}
                                                        className=""
                                                        initialValue={profile.name}
                                                    >
                                                        <Input placeholder="Enter the name" />
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Contact Number<span>(Optional)</span></label>
                                                    <p>The primary contact number to reach out to you</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                    <ConfigProvider
                                                        locale={en}
                                                        areaMapper={(area) => {
                                                            return {
                                                                ...area,
                                                                emoji: (
                                                                    <img
                                                                        alt="flag"
                                                                        style={{
                                                                            width: 18,
                                                                            height: 18,
                                                                            verticalAlign: "sub",
                                                                        }}
                                                                        src={getFlag(area.short)}
                                                                    />
                                                                ),
                                                            };
                                                        }}
                                                    >
                                                        <Form.Item
                                                            name="contact"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "This field is required",
                                                                },
                                                            ]}
                                                            className=""
                                                            initialValue={{
                                                                short:
                                                                    profile.contact_number?.substring(
                                                                        0,
                                                                        profile.contact_number.indexOf(
                                                                            "-"
                                                                        )
                                                                    ),
                                                                phone:
                                                                    profile.contact_number?.substring(
                                                                        profile.contact_number.indexOf(
                                                                            "-"
                                                                        ) + 1
                                                                    ),
                                                            }}
                                                        >
                                                            <CountryPhoneInput
                                                                className="intlPhone"
                                                                placeholder="Enter the alternate contact number"
                                                                // defaultValue={{ short: "IN" }}
                                                                initialValue={
                                                                    profile?.contact_number
                                                                }
                                                            />
                                                        </Form.Item>
                                                    </ConfigProvider>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Email Address</label>
                                                    <p>The registered email id to access the product</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                    <Form.Item name="email"
                                                        rules={[{ required: true, type: 'email' }]}
                                                        className=""
                                                        initialValue={profile.email}
                                                    >
                                                        <Input placeholder="Enter the email id" disabled />
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Department<span> (Optional)</span></label>
                                                    <p>Primary department you are associated with</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                    <Form.Item name="department"
                                                        className=""
                                                        initialValue={profile.department}
                                                        rules={[
                                                            { max: 50, message: "Department can't have more than 50 characters" },
                                                        ]}
                                                    >
                                                        <Input placeholder="Enter the Department" />
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>


                            </Form>
                        </div>
                    </HaberForm>
                </DetailFields>
                {showToaster && (
                    <AlertContainer
                        closeIcon={true}
                        setClose={showToaster}
                        color={`${toaster.error ? "red" : "green"} toaster`}
                        icon={toaster.error ? alertRed : alertGreen}
                        msg={toaster.msg}
                    />
                )}
            </RightLayoutContainer> : <></>
    )
}

export default ProfileEditData;